<ng-container *adaptIfAlto="false">
    <adapt-page-with-splash-image leftColumnWidthClasses="col-12 col-md-8 col-xl-6 overflow-hidden h-100"
                                  rightColumnWidthClasses="col d-sm-none d-md-block"
                                  [fitHeight]="true">
        <ng-container *ngTemplateOutlet="pageContent"></ng-container>
    </adapt-page-with-splash-image>
</ng-container>
<div *adaptIfAlto="true"
     class="d-flex w-100 h-100 justify-content-center">
    <div class="alto-survey-container col-xl-8 col-lg-10">
        <ng-container *ngTemplateOutlet="pageContent"></ng-container>
    </div>
</div>
<ng-template #pageContent>
    @if (!errorMessage && surveyDetails) {
        <div class="d-flex flex-column h-100">
            @if (!isLoggedIn && !surveyDetails!.organisationImageIdentifier) {
                <a href="https://theadaptway.com"
                   aria-label="Go to adapt website"
                   target="_blank">
                    <img width="120"
                         [src]="isAlto ? '/content/shell/images/adapt-logo.svg' : '/content/shell/images/adapt-lumia-logo.svg'"
                         alt="adapt logo" />
                </a>
            }
            <div class="d-flex survey-header">
                <!-- TODO: reinstate when CM-6236 is done
                    if (!isLoggedIn && surveyDetails!.organisationImageIdentifier) {
                    <adapt-storage-image class="me-3 mb-3"
                    [imageIdentifier]="surveyDetails!.organisationImageIdentifier"></adapt-storage-image>
                -->
                <h1>{{ title }}</h1>
            </div>
            @if (!errorMessage && surveyDetails) {
                <dx-scroll-view showScrollbar="always"
                                (onScroll)="onScrolled($event)"
                                [scrollByContent]="true"
                                [scrollByThumb]="true"
                                [useNative]="true"
                                data-test="survey-questions-scroll">
                    @if (submitted) {
                        <div>
                            <h3 class="mt-3">Thank you for completing the survey!</h3>
                            <p>Your responses have been submitted successfully. When the survey has ended you will be able to see the
                                anonymised results and analysis.</p>
                            @if (isLoggedIn) {
                                <p>
                                    <a routerLink="/"><i class="fal fa-chevron-left"></i> Back to dashboard</a>
                                </p>
                            }
                        </div>
                    } @else {
                        <div class="survey-details">
                            @if (surveyDetails!.surveyEndTime) {
                                <h3>
                                    Open until
                                    {{ surveyDetails!.surveyEndTime | adaptDateTime }}
                                </h3>
                                <br />
                            }
                            @if (!introArticle) {
                                <div [innerHTML]="surveyDescription"></div>
                            } @else {
                                <adapt-implementation-kit-content [articleId]="introArticle"
                                                                  (contentLoaded)="scrollViewInstance?.update()">
                                </adapt-implementation-kit-content>
                            }
                        </div>
                        @if (surveyQuestionsGroupedByCategory.length < 1) { @for (question of surveyQuestions; track question) {
                                <div class="survey-question"
                                     [ngClass]="getAdditionalQuestionStyle(question.ordinal)"
                                     [attr.id]="'question_' + question.ordinal"
                                     (click)="onItemClick($event)"
                                     data-test="survey-question">
                                    <div class="question-text mb-2">
                                        <span>{{ question.questionText }}</span>
                                    </div>
                                    <dx-radio-group [items]="questionResponses"
                                                    [(value)]="question.response"
                                                    (onValueChanged)="onAnswered(question, $event)"
                                                    valueExpr="value"
                                                    displayExpr="text"
                                                    class="ms-3"> </dx-radio-group>
                                </div>
                            }
                        } @else {
                            @for (category of surveyQuestionsGroupedByCategory; track category) {
                                <hr />
                                <h2 class="category-header">
                                    {{ category.categoryName }}
                                </h2>
                                @for (question of category.questions; track question) {
                                    <div class="survey-question"
                                         [ngClass]="getAdditionalQuestionStyle(question.ordinal)"
                                         [attr.id]="'question_' + question.ordinal"
                                         (click)="onItemClick($event)">
                                        <div class="question-text mb-2">
                                            <span>{{ question.questionText }}</span>
                                        </div>
                                        <dx-radio-group [items]="questionResponses"
                                                        [(value)]="question.response"
                                                        (onValueChanged)="onAnswered(question, $event)"
                                                        valueExpr="value"
                                                        displayExpr="text"
                                                        class="ms-3"> </dx-radio-group>
                                    </div>
                                }
                            }
                        }
                        <div class="d-flex justify-content-center me-3">
                            @if (!isTokenlessSurvey) {
                                <button adaptButtonIcon="save"
                                        [disabled]="incomplete || isSubmitting"
                                        class="btn btn-primary"
                                        (click)="submitResponse()"
                                        data-test="submit-survey-button">Submit responses</button>
                            }
                            @if (isTokenlessSurvey) {
                                <button adaptButtonIcon="fal fa-fw fa-sign-in"
                                        [disabled]="incomplete || isSubmitting"
                                        class="btn btn-primary"
                                        (click)="analyseResults()"
                                        data-test="submit-survey-button">Sign up to analyse my results</button>
                            }
                        </div>
                        @if (submitErrorMessage) {
                            <div class="mt-3 alert alert-danger">
                                <span>{{ submitErrorMessage }}</span>
                            </div>
                        }
                    }
                </dx-scroll-view>
                @if (!submitted) {
                    <div class="mt-3 me-3 question-progress">
                        <div class="text-center">
                            {{ answeredQuestionCount }} /
                            {{ totalQuestionCount }}
                        </div>
                        <dx-progress-bar width="100%"
                                         [min]="0"
                                         [max]="totalQuestionCount"
                                         [value]="answeredQuestionCount"
                                         [showStatus]="false"></dx-progress-bar>
                    </div>
                }
            } @else {
                <adapt-dashboard-element>
                    @if (!isLoggedIn) {
                        <div adapt-dashboard-title>
                            <h2>Survey: {{ surveyNameFromParam }}</h2>
                        </div>
                    }
                    <div class="alert alert-danger"
                         role="alert">
                        {{ errorMessage }}
                    </div>
                    @if (isLoggedIn) {
                        <div>
                            <a routerLink="/"><i class="fal fa-chevron-left"></i> Back to dashboard</a>
                        </div>
                    }
                </adapt-dashboard-element>
            }
        </div>
    } @else {
        <adapt-dashboard-element>
            @if (!isLoggedIn) {
                <div adapt-dashboard-title>
                    <h2>Survey: {{ surveyNameFromParam }}</h2>
                </div>
            }
            <div class="alert alert-danger"
                 role="alert">
                {{ errorMessage }}
            </div>
            @if (isLoggedIn) {
                <div>
                    <a routerLink="/"><i class="fal fa-chevron-left"></i> Back to dashboard</a>
                </div>
            }
        </adapt-dashboard-element>
    }
</ng-template>
